import React, { useEffect } from 'react';
import Message from '../common/Message';
import ProgramsSection from './ProgramsSection';
import Testimonials from './Testimonials';
import { Gallery } from './Gallery';
import Hero from './Hero';
import { useHeader } from '../../contexts/HeaderContext';
import { motion, useScroll, useTransform } from 'framer-motion';

const HomePage: React.FC = () => {
    const { setHeaderTheme } = useHeader();
    const { scrollY } = useScroll();
    const backgroundY = useTransform(scrollY, [0, 10000], [0, 100]);

    useEffect(() => {
        // 设置透明背景和主题色文字
        setHeaderTheme({
            bgColor: 'bg-transparent',
            textColor: 'text-white'
        });

        return () => {
            // 恢复默认主题
            setHeaderTheme({
                bgColor: 'bg-white',
                textColor: 'text-[#142b89]'
            });
        };
    }, [setHeaderTheme]);

    return (
        <div className="min-h-screen relative overflow-hidden">
            {/* 背景图层 - 使用视差效果 */}
            <motion.div 
                className="fixed inset-0 w-full h-full bg-cover bg-center bg-no-repeat z-0" 
                style={{ 
                    backgroundImage: 'url(/images/default-bg.jpg)',
                    y: backgroundY
                }}
            />
            
            {/* 半透明覆盖层，提供更好的对比度 */}
            <div className="fixed inset-0 bg-blue-900/30 backdrop-blur-[1px] z-0"></div>
            
            {/* 内容区域 */}
            <div className="relative z-10">
                <Hero />
                {/* <div className="">
                    <div className="">
                        <Gallery />
                    </div>
                    <div className="">
                        <Message />
                    </div>
                    <div className="">
                        <ProgramsSection />
                    </div>
                    <div className="">
                        <Testimonials />
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default HomePage; 